import {btn_c_whiteToHighlight,
  btn_sm,
  svg_sm,
  svg_md,
  svg_inline,
  font_s_sm,
  font_s_md,
  colors,
  clearfix, absCenterY
} from '@xpertdox_js/xdstyle';

export default {
  editSection: {
    borderBottom: '1px solid #dadcde',
    cursor: 'pointer',
    position: 'relative',
    transition: 'height .18s ease-out, max-height .18s ease-out'
  },
  editSectionHov: {
    background: '#fafbff',
  },
  fieldContainer: {
    ...clearfix,
    position: 'relative',
  },
  contentWrap: {
    float: 'left',
    width: '100%'
  },
  contentInnerWrap: {
    ...clearfix,
    width: '98%'
  },
}
